import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { I2faType, SessionService } from 'pod-ng-core';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

interface IConfirm2faSmsModel {
  confirmation: string;
}

@Component({
  selector: 'app-confirm-2fa-sms',
  templateUrl: './confirm-2fa-sms.component.html',
})
export class Confirm2faSmsComponent implements OnInit {
  private _token: string;
  @Input() get token(): string {
    return this._token;
  }
  set token(token: string) {
    this._token = token;

    try {
      // const parsedToken = JSON.parse(
      //   Buffer.from(token, 'base64').toString('utf8')
      // );

      console.log(atob(token));
      const parsedToken = JSON.parse(atob(token));
      this.ofuscatedPhone = parsedToken?.value;
    } catch (error) {
      this.ofuscatedPhone = null;
    }
    this.ofuscatedPhone;
  }
  @Input() blockButtons = false;
  @Output() onSubmit = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onTokenChange = new EventEmitter<string>();

  public model: IConfirm2faSmsModel;
  public submitting = false;
  public ofuscatedPhone: string;
  public error: string;

  constructor(
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private session: SessionService
  ) {}

  ngOnInit() {
    this.model = {
      confirmation: null,
    };
  }

  public repeatCode(form: NgForm) {
    this.submitting = true;
    this.error = null;
    this.session
      .repeat2faCode(I2faType.SMS, this.token)
      .pipe(
        finalize(() => {
          this.submitting = false;
          form.resetForm({
            confirmation: null,
          });
          this.toastrService.success(
            this.translateService.instant('message.newCodeSent')
          );
        })
      )
      .subscribe({
        next: result => {
          this.token = result.token;
        },
        error: err => {
          this.error =
            err?.error?.message ||
            this.translateService.instant('message.unableToResendCode');
        },
      });
  }

  // See https://github.com/DethAriel/ng-recaptcha for recaptcha
  public submit(form: NgForm) {
    if (form.valid) {
      this.error = null;
      this.submitting = true;
      this.session
        .confirm2faCode(I2faType.SMS, this.model.confirmation, this.token)
        .pipe(finalize(() => (this.submitting = false)))
        .subscribe({
          next: logged => {
            this.onSubmit.emit(logged);
          },
          error: err => {
            console.error(err);
            form.resetForm({
              confirmation: null,
            });
            this.error =
              err?.error?.message ||
              this.translateService.instant(
                'message.incorrectVerificationNumber'
              );
          },
        });
    }
  }
}
